import {useEffect} from "react";
import {useLoader, useThree} from "@react-three/fiber";
import {RGBELoader} from "three-stdlib";
import * as logger from "../utils/logger";

export const HDRIFlatBackground = ({ hdriURL }) => {
    const scene = useThree((s) => s.scene);
    const texture = useLoader(RGBELoader, hdriURL);

    logger.debug("[d8s renderer]: rendering flat HDRI preview for url: ", hdriURL);

    useEffect(() => {
        scene.background = texture;
    }, [texture]);

    return null;
};
